// Bridges the app's `yyyy-mm-dd` date strings (what forms store / send to the backend) and the
// `Date` objects react-datepicker works with. Parses/formats in LOCAL time so a picked calendar
// day never shifts by one via a UTC round-trip.

export const ymdToDate = (ymd?: string | null): Date | null =>
  ymd ? new Date(`${ymd}T00:00:00`) : null;

export const dateToYmd = (d: Date | null): string => {
  if (!d) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
